import { createAsyncThunk } from "@reduxjs/toolkit";
import { typedAdminAPI } from "../api/typedApi";

export const getMarathonDetails = createAsyncThunk(
  "admin/getMarathonDetails",
  async (id: number | null) => {
    try {
      const { data } = await typedAdminAPI.getMarathonDetails(id);
      return data;
    } catch (error) {
      console.log("Error while getting marathon details", error);
    }
  }
);
